/**
 * 比价报名页面路径
 */
export const PRICE_COMPARE_APPLY_PAGE_PATH = '/priceCompare/apply'
